module.exports = __webpack_public_path__ + "static/media/wer-end@2x.db6a7d44.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/wer-end@2x.jpg
// module id = 852
// module chunks = 0